import constants from '@/helpers/constants'

export default {
    created () {
        this.constants = constants
    }
}
